import * as firebase from "firebase";

// Initialize Firebase
let database, storage, auth;
let config = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  databaseURL: process.env.REACT_APP_databaseURL,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId
};
export const fire = () => {
  if (!firebase.apps.length) {
    firebase.initializeApp(config);
  }
  database = firebase.database();
  storage = firebase.storage();
  auth = firebase.auth();
};
export const getAuth = () => {
  return auth;
};

export const getFireDB = () => {
  return database.ref("/").once("value");
};

export const getBoard = () => {
  return database.ref().child("boards");
};

export const getFacility = () => {
  return database
    .ref()
    .child(
      process.env.NODE_ENV === "development" ? "dev-facilities" : "facilities"
    );
};

export const deleteBoards = id => {
  return getBoard()
    .child(id)
    .remove();
};

export const getImage = () => {
  return storage.ref().child("images");
};

export const getFacilityImage = () => {
  return storage
    .ref()
    .child(
      process.env.NODE_ENV === "development" ? "dev-facilities" : "facilities"
    );
};

export const deleteImage = file => {
  return getImage()
    .child(file)
    .delete();
};

// Firebase Storage REST API로 rooms/{folder}/ 내 이미지 URL 목록 반환
export const getRoomImages = (folder) => {
  const bucket = process.env.REACT_APP_storageBucket;
  const prefix = `rooms/${folder}/`;
  return fetch(
    `https://firebasestorage.googleapis.com/v0/b/${bucket}/o?prefix=${encodeURIComponent(prefix)}`
  )
    .then((res) => res.json())
    .then((data) => {
      if (!data.items || data.items.length === 0) return [];
      return data.items
        .sort((a, b) => {
          const numA = parseInt(a.name.replace(/.*\/(\d+).*/, '$1'), 10);
          const numB = parseInt(b.name.replace(/.*\/(\d+).*/, '$1'), 10);
          return numA - numB;
        })
        .map(
          (item) =>
            `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(item.name)}?alt=media`
        );
    })
    .catch(() => []);
};

export const getComment = () => {
  return database
    .ref()
    .child("boards")
    .child("comment");
};

export const emailAuth = (email, actionCodeSettings) => {
  return auth
    .sendSignInLinkToEmail(email, actionCodeSettings)
    .then(function() {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem("passwordForSignIn", email);
    })
    .catch(function(error) {
      // Some error occurred, you can inspect the code: error.code
    });
};



// WEBPACK FOOTER //
// ./src/utils/Firebase.js